const STORAGE_KEY = 'smarthoa.activeOnboardingPath';

function getStorage() {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
}

export function readOnboardingPath(storage = getStorage()) {
    if (!storage) return null;
    try {
        return JSON.parse(storage.getItem(STORAGE_KEY));
    } catch {
        storage.removeItem(STORAGE_KEY);
        return null;
    }
}

export function startOnboardingPath(goal, currentPage, storage = getStorage()) {
    if (!storage || !goal || !currentPage) return;
    storage.setItem(STORAGE_KEY, JSON.stringify({ goal, currentPage }));
}

export function clearOnboardingPath(storage = getStorage()) {
    storage?.removeItem(STORAGE_KEY);
}

export function finishOnboardingPath(goal, storage = getStorage()) {
    if (readOnboardingPath(storage)?.goal === goal) clearOnboardingPath(storage);
}

export function isExpectedOnboardingPage(goal, path, storage = getStorage()) {
    const activePath = readOnboardingPath(storage);
    return activePath?.goal === goal && activePath.currentPage === path;
}

export function getOnboardingResumePath(goal, progress = {}) {
    if (goal === 'accounting') {
        if (!progress.categories) return '/budget';
        if (!progress.bank) return '/accounts';
        return '/reports';
    }
    if (goal === 'dues') {
        if (!progress.members) return '/members';
        if (!progress.dues) return '/dues';
        return '/invoices';
    }
    return null;
}

export function trackOnboardingNavigation(fromPath, toPath, storage = getStorage()) {
    const activePath = readOnboardingPath(storage);
    if (!activePath || toPath === '/' || toPath === '/onboarding') return;
    if (toPath === activePath.currentPage) return;

    const nextPages = activePath.goal === 'accounting'
        ? { '/budget': '/accounts', '/accounts': '/reports', '/reports': '/transactions', '/transactions': '/reports' }
        : { '/members': '/dues', '/dues': '/invoices', '/invoices': '/profile', '/profile': '/invoices' };

    if (fromPath === activePath.currentPage && nextPages[activePath.currentPage] === toPath) {
        startOnboardingPath(activePath.goal, toPath, storage);
    } else {
        clearOnboardingPath(storage);
    }
}
